module.exports = __webpack_public_path__ + "img/all_bottles.21d9940b.jpg";